














































import { defineComponent, ref } from "@vue/composition-api";
import OccModal from "@/components/Atoms/OccModal/index.vue";
import OccHeading from "@/components/Atoms/OccHeading/index.vue";
import OccRadio from "@/components/Atoms/OccRadio/index.vue";
import OccButton from "@/components/Atoms/OccButton/index.vue";
import { PartnerEntryUserSelectionStatus } from "@/api/types";
import { selectionStatusMapping } from "@/helpers/partnerEntryUsers";

/**
 * 選考ステータス 変更モーダル
 */
export default defineComponent({
  components: {
    OccModal,
    OccHeading,
    OccRadio,
    OccButton
  },
  name: "SelectionStatusBulkChangeModal",
  emits: ["close", "apply"],
  props: {
    selectedCount: {
      type: Number,
      require: true,
      validator: (selectedCount: number) => {
        return selectedCount >= 1;
      }
    }
  },
  setup(_, { emit }) {
    const selectedOptionValue = ref<PartnerEntryUserSelectionStatus>();

    const onChange = (selectionStatus: PartnerEntryUserSelectionStatus) => {
      selectedOptionValue.value = selectionStatus;
    };

    const isChecked = (selectionStatus: PartnerEntryUserSelectionStatus) => {
      return selectedOptionValue.value === selectionStatus;
    };

    const apply = () => {
      emit("apply", selectedOptionValue.value);
    };

    return {
      selectionStatusMapping,

      selectedOptionValue,
      onChange,
      isChecked,
      apply
    };
  }
});
